<template>
  <div class="status-change-procedure-apply-input">
    <div class="main">
      <div class="main-cont"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <AppScrollbar style="height: 100%">
          <div class="apply-main">
            <div class="header">
              <slot></slot>
            </div>
            <div class="body">
              <div class="form-wrap">
                <div class="header">
                  <span class="title theme-text">异动类型：{{label}}</span>
                </div>
                <div class="body">
                  <slot name="form"></slot>
                </div>
              </div>
            </div>
          </div>
        </AppScrollbar>
      </div>
    </div>
    <div class="footer">
      <el-button size="mini"
                 type="primary"
                 :disabled="committing"
                 @click="handleApply">确认异动</el-button>
      <el-button size="mini"
                 type="default"
                 @click="handleClose">取消操作</el-button>
    </div>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
export default {
  name: 'StatusChangeProcedureApplyInput',
  components: {
    AppScrollbar
  },
  props: {
    label: String,
    resolveForm: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      committing: false
    }
  },
  methods: {
    handleApply () {
      this.resolveForm().then(result => {
        this.$confirm('确定要提交本次异动操作吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.committing = true
          this.$ajax(this.$extend(result, {
            method: 'post'
          })).then(response => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message.success(response.data['message'])
                  this.$nextTick(() => {
                    this.$emit('change-success')
                  })
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  break
                }
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          }).finally(() => {
            this.committing = false
          })
        }).catch(() => {})
      }, err => {
        this.$message.warning(err.message)
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  }
}
</script>

<style lang="scss">
  .status-change-procedure-apply-input {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .apply-main {
          padding: 10px;
          & > .body {
            margin-top: 20px;
            & > .form-wrap {
              padding: 12px 15px 15px;
              box-shadow: 0 0 6px rgba(0,0,0,.1);
              border-radius: 4px;
              & > .header {
                & > .title {
                  font-size: 12px;
                }
              }
              & > .body {
                margin-top: 15px;
                padding-bottom: 30px;
                .el-form {
                  max-width: 100%;
                  width: 640px;
                  .el-form-item {
                    margin-bottom: 15px;
                    &:last-child {
                      margin-bottom: 0;
                    }
                    .el-form-item__label {
                      color: #909399;
                      font-size: 12px;
                      text-align: left;
                    }
                    .el-form-item__content {
                      font-size: 12px;
                      .el-select,
                      .el-textarea {
                        width: 100%;
                      }
                      .el-input-number {
                        max-width: 100%;
                        width: 145px;
                        .el-input__inner {
                          text-align: left;
                        }
                      }
                      .date-range {
                        display: flex;
                        align-items: center;
                        & > .el-date-editor {
                          flex: auto;
                        }
                        & > .divider {
                          margin-left: 8px;
                          margin-right: 8px;
                          flex: none;
                        }
                      }
                      .date-period-range {
                        display: flex;
                        align-items: center;
                        & > .period {
                          flex: auto;
                          display: flex;
                          align-items: center;
                          & > .el-select {
                            flex: auto;
                          }
                          & > .unit {
                            margin-left: 10px;
                            flex: none;
                          }
                          & + .period {
                            margin-left: 10px;
                          }
                        }
                      }
                      .input-group {
                        max-width: 100%;
                        display: inline-flex;
                        align-items: center;
                        & > .el-input-number {
                          flex: auto;
                        }
                        & > .unit {
                          margin-left: 10px;
                          flex: none;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    & > .footer {
      flex: none;
      position: relative;
      height: 52px;
      background-color: #fff;
      text-align: center;
      line-height: 50px;
      &:before {
        content: '';
        position: absolute;
        left: 10px;
        right: 10px;
        top: 0;
        height: 1px;
        background-color: #ebeef5;
      }
    }
  }
</style>
